var target_search_template = require('./target_search_modal.twig');

import { Dropdown } from '../../components/Dropdown'
import { CustomModal } from "../../components/customModal";

export class TargetSearch
{
    constructor(meetingData, meetingPhase) {
        this.meetingData = meetingData
        this.meetingPhase = meetingPhase;
        let show_add_form = true
        let target_columns = []
        let show_hcp_type_filter = app.appData?.opco_config?.sb?.attendance?.enable_hcp_type_filter ?? false;
        let buttonName = (app.appData?.opco_config?.sb?.attendance?.enable_target_form ?? false) ? 'Select' : 'Add';
        let requiredFields = JSON.parse(app.appData.configs.SEARCH_UNIVERSE_MINIMUM_CRITERIA ?? '["lastname"]');
        if (!Array.isArray(requiredFields) || requiredFields.length === 0) {
          requiredFields = ["lastname"];
        }
        this.requiredFields = requiredFields;
        this.showHcpTypeFilter = show_hcp_type_filter;

        let excludeAbbottOpcos = app.appData.configs?.EXCLUDE_ABBOTT_CUSTOMER_NUMBER ?? '[]';
        excludeAbbottOpcos = excludeAbbottOpcos.replace(/^\['|']$/g, '').split("','");
        const currentOpcoCode = this.meetingData.opco_code ?? '';
        this.showAbbottCustomerNumber = this.isAllerganClient() && !excludeAbbottOpcos.includes(currentOpcoCode);

        if(typeof app.appData.projects[this.meetingData.project_id].program_types[this.meetingData.program_type_id].configuration.manage_attendance.show_add_form !== 'undefined') {
            show_add_form = app.appData.projects[this.meetingData.project_id].program_types[this.meetingData.program_type_id].configuration.manage_attendance.show_add_form
        }

        let targetTable = [...app.appData.layout.attendance.target_table];

        if (this.showHcpTypeFilter) {
            targetTable.push({
                data: 'hcp_type',
                name: 'HCP Type'
            });
        }

        if (this.showAbbottCustomerNumber) {
            targetTable.push({
                data: 'customer_id',
                name: 'Abbott Customer Number'
            });
        }

        this.dom = $(twig({ data: target_search_template }).render({
            show_add_form: show_add_form,
            show_cust: app.appData.layout.attendance.customer_filter,
            table_data: targetTable,
            topic_sources: this.meetingData.topic_sources,
            notice_msg: app.appData.layout.attendance.notice_msg ?? false,
            show_guidance_text : (app.appData.configs?.SHOW_GUIDANCE_TEXT) ?? false,
            show_hcp_type_filter: this.showHcpTypeFilter,
            show_abbott_customer_number: this.showAbbottCustomerNumber
        }))

        for (var val in targetTable) {
            target_columns.push({'data': targetTable[val].data})
        }

        target_columns.push({
            'data': 'target_id',
            render : (data, type, row) => {
                if(row.can_add)
                {
                    return (
                      '<button type="button" class="btn btn-sm btn-primary add-target"  data-target-id="' +
                      row.target_id +
                      '" data-customer-id="' +
                      row.customer_id +
                      '" data-address-id="' +
                      row.address_id +
                      '" data-address-index="' +
                      row.address_index +
                      '" data-name="' +
                      row.firstname +
                      " " +
                      row.lastname +
                      '" data-ship_to="' +
                      row.ship_to +
                      '" data-inv-deg="' +
                      row.invalid_degree +
                      '"data-inv-spec="' +
                      row.invalid_specialty +
                      '"> ' +
                      buttonName +
                      "</button>"
                    );
                }
                else
                {
                    return '';
                }
            }
        })

        this.datatable = this.dom.find("#datatable_targets").DataTable({
            "processing": true,
            "serverSide": true,
            "ordering": false,
            "ajax": {
                "url": "api/attendance/searchtargets",
                "data": (d) => {
                    d.data = this.filterData;
                    d.meeting_id = $("#meeting_id").val();
                }
            },
            "columns": target_columns,
            "pagingType": "full_numbers",
            "width" : "100%",
            "dom": '<"row"<"col-6"l><"col-6"<"row">>><t>pri',
            "deferLoading": 1,
            "pageLength": 25,
            "scrollCollapse": true,
            "language": {
                "loadingRecords": 'Please wait while we fetch your results.',
                "emptyTable":     "No Results",
                "processing": 'Please wait while we fetch your results.'
            },
            "drawCallback": function() {
                app.convertDatatableToCard("datatable_targets");
            }
        });

        this.renderFilterDDs();
        this.setRequired();

        // Enable/Disable the search button based on some criteria
        const inputs = '#target_search_customer_id, #target_search_firstname, #target_search_lastname, #target_search_city, #state, #degree, #specialty_code, #hcp_type';
        this.demographicFieldsSelector = `${inputs}, #target_search_npi_num`;

        this.dom.find(inputs).on('keyup change', () => {
            this.handleDemographicInputChanged();
            this.updateSearchButtonState();
        });

        // Npi validations
        this.dom.find("#target_search_npi_num").on("keyup", (e) => {
          this.handleDemographicInputChanged();
          let errorElement = this.dom.find("#error-message");
          let flag =
            !this.checkNpiValidation(errorElement, e.target.value) ||
            !this.canSearch();
          this.dom.find('#target_filter button[type="submit"]').prop("disabled", flag);
        });

        if (this.showAbbottCustomerNumber) {
            this.dom.find('#target_search_abbott_customer_number').on('keyup change', () => {
                this.handleAbbottInputChanged();
                this.updateSearchButtonState();
            });
        }

        this.dom.find('#target_search_reset_btn').on('click', () => {
            this.reset();
        });

        this.dom.find('#form_filter_targets').on('submit', (e) => {
            e.preventDefault()
            this.dom.find('.attendee-val-message').hide()
            this.setFilterData()

            this.datatable.ajax.reload(() => {
                this.dom.find('.add_attendee_via_form_button').show();
            });
        });

        this.dom.find('#datatable_targets tbody').on('click', '.add-target', (e) => {
            this.handleAddTarget(e);
        });

        this.dom.find('.add_attendee_via_form_button').on('click', (event) => {
            this.modal.hide();
            app.pages.attendance.dom.trigger('addViaFormClicked', [event, this.filterData])
        })

        this.modal = new bootstrap.Modal(this.dom, {backdrop: 'static', keyboard: false, show: false});
    }

    renderFilterDDs() {
        let specialtyDD = new Dropdown(app.format.getSortedSpecialties())
        specialtyDD
           .label('Specialty')
           .draw(this.dom.find("#target_search_specialty-dd-container"), 'code', 'short_name', 'specialty_code')
        this.dom.find('#target_search_specialty-dd-container > select').addClass("input-group-text")

        let degreeDD = new Dropdown(app.format.getSortedDegreesByAbbreviation())
        degreeDD
           .label('Degree')
           .draw(this.dom.find("#target_search_degree-dd-container"), 'degree_abbrv', 'degree_abbrv', 'degree')
        this.dom.find('#target_search_degree-dd-container > select').addClass("input-group-text")

        let statesDD = new Dropdown(app.appData.states)
        statesDD
            .label('State')
            .draw(this.dom.find("#target_search_state_dd-container"), 'alpha2', 'name', 'state')
        this.dom.find('#target_search_state_dd-container > select').addClass("input-group-text")

        if (this.showHcpTypeFilter) {
            let hcpTypeData = [
                { value: 'Prescriber', label: 'Prescriber' },
                { value: 'Non-Prescriber', label: 'Non-Prescriber' },
                { value: 'Pharmacists', label: 'Pharmacists' }
            ];

            let hcpTypeDD = new Dropdown(hcpTypeData)
            hcpTypeDD
                .label('HCP Type')
                .draw(this.dom.find("#target_search_hcp_type-dd-container"), 'value', 'label', 'hcp_type')
            this.dom.find('#target_search_hcp_type-dd-container > select').addClass("input-group-text")
        }
    }

    setRequired() {
      const fields = [
        { field: "firstname", fieldId: "#target_search_firstname" },
        { field: "lastname", fieldId: "#target_search_lastname" },
        { field: "city", fieldId: "#target_search_city" },
        { field: "npi_num", fieldId: "#target_search_npi_num" },
        { field: "state", fieldId: "#state" },
        { field: "degree", fieldId: "#degree" },
        { field: "specialty", fieldId: "#specialty_code" },
      ];

      if (this.showHcpTypeFilter) {
        fields.push({ field: "hcp_type", fieldId: "#hcp_type" });
      }

      this.requiredFields.forEach((requiredField) => {
        const match = fields.find((item) => item.field === requiredField);
        if (!match) {
          return;
        }

        const element = this.dom.find(match.fieldId);
        if (!element) {
          return;
        }

        element.addClass("required is-invalid");
        element.prop("required", true);
      });
    }

    checkFieldRequired(key, isvalid) {
      const fields = [
        { field: "firstname", fieldId: "#target_search_firstname" },
        { field: "lastname", fieldId: "#target_search_lastname" },
        { field: "city", fieldId: "#target_search_city" },
        { field: "npi_num", fieldId: "#target_search_npi_num" },
        { field: "state", fieldId: "#state" },
        { field: "degree", fieldId: "#degree" },
        { field: "specialty", fieldId: "#specialty_code" },
      ];

      if (this.showHcpTypeFilter) {
        fields.push({ field: "hcp_type", fieldId: "#hcp_type" });
      }

      const match = fields.find((item) => item.field === key);
      if (!match) {
        return;
      }

      const element = this.dom.find(match.fieldId);
      if (!element) {
        return;
      }
      if (element.val() && isvalid) {
        element.removeClass("is-invalid");
      } else {
        element.addClass("is-invalid");
      }
    }

    reloadDatatable() {
        this.datatable.ajax.reload();
    }

    setFilterData() {
        this.filterData = {};
        this.dom.find("#form_filter_targets input, #form_filter_targets select").each((index ,elem) => {
            const $elem = $(elem);
            // Disabled fields belong to the search mode (existing filters vs. Abbott
            // Customer Number) that is not currently active - exclude them so the
            // request only ever carries one search method's criteria.
            if ($elem.prop('disabled')) {
                return;
            }
            this.filterData[$elem.attr('name').replace('target_search_', '')] = $elem.val();
        });
        this.filterData['attendee_code'] = app.appData.projects[this.meetingData.project_id].program_types[this.meetingData.program_type_id].configuration.manage_attendance.only_search_ace_targets ? 'ace' : '';
    }

    /*
        Require minimum filter criteria to be entered before enabling the search button. By default, that will remain set to just the "lastname" input.

        - Text inputs must have at least 2 characters
        - Select inputs must have a valid option chosen
        - An empty array on ref_config.SEARCH_UNIVERSE_MINIMUM_CRITERIA means at least 1 input has search data meeting the above rules
        - The config array can otherwise contain any combination of input names as defined in the ipt_validation object below
    */
    canSearch()
    {
        // Abbott Customer Number is an alternative, mutually exclusive search method -
        // it must be able to enable the Search button on its own, without satisfying
        // the existing required-field rules below (e.g. Last Name).
        if (this.showAbbottCustomerNumber) {
            const abbottValue = (this.dom.find('#target_search_abbott_customer_number').val() ?? '').trim();
            if (abbottValue.length > 1) {
                return true;
            }
        }

        let ipt_validation = {
            customer_id:    (this.dom.find('#target_search_customer_id').val() ?? '').trim().length > 1,
            firstname:      (this.dom.find('#target_search_firstname').val() ?? '').trim().length > 1,
            lastname:       (this.dom.find('#target_search_lastname').val() ?? '').trim().length > 1,
            city:           (this.dom.find('#target_search_city').val() ?? '').trim().length > 1,
            state:          !['', null].includes((this.dom.find('#state').val() ?? '')),
            degree:         !['', null].includes((this.dom.find('#degree').val() ?? '')),
            specialty:      !['', null].includes((this.dom.find('#specialty_code').val() ?? '')),
            npi_num:        this.checkNpiNumberValidation((this.dom.find('#target_search_npi_num').val() ?? '').trim())
        };

        if (this.showHcpTypeFilter) {
            ipt_validation.hcp_type = (!['', null].includes((this.dom.find('#hcp_type').val() ?? '')));
        }

        let criteria = this.requiredFields;
        if(criteria.length > 0){
            // If any rules have been specified, make sure each of them passes their check
            let pass_count = 0;
            for(let ipt in criteria){
                let isValid = false;
                if(ipt_validation[criteria[ipt]] && ipt_validation[criteria[ipt]] === true){
                    pass_count++;
                    isValid = true;
                }
                this.checkFieldRequired(criteria[ipt], isValid);
            }

            if(pass_count == criteria.length){
                return true;
            }
        }else{
            // If no rules have been specified, make sure at least 1 input contains data to search with
            for(let key in ipt_validation){
                if(ipt_validation[key] === true){
                    return true;
                }
            }
        }

        return false;
    }

    reset() {
        let topicSources = this.dom.find("[name='sources']").val()
        this.dom.find('#form_filter_targets')[0].reset()
        this.dom.find("[name='sources']").val(topicSources)
        this.dom.find('.add_attendee_via_form_button').hide()
        this.dom.find('#target_filter button[type="submit"]').prop('disabled', true)
        this.dom.find('.attendee-val-message').hide()
        this.dom.find('#error-message').empty().hide()

        this.setRequired();
        if (this.showAbbottCustomerNumber) {
            // Native form reset() clears values but not the disabled state applied by
            // the mutual-exclusion handlers, so both search modes must be re-enabled.
            this.dom.find(this.demographicFieldsSelector).prop('disabled', false)
            this.dom.find('#target_search_abbott_customer_number').prop('disabled', false)
        }
    }

    hasDemographicValue() {
        let hasValue = false;
        this.dom.find(this.demographicFieldsSelector).each((index, elem) => {
            if (($(elem).val() ?? '').toString().trim() !== '') {
                hasValue = true;
            }
        });
        return hasValue;
    }

    handleDemographicInputChanged() {
        if (!this.showAbbottCustomerNumber) {
            return;
        }

        const abbottInput = this.dom.find('#target_search_abbott_customer_number');
        if (this.hasDemographicValue()) {
            abbottInput.val('').prop('disabled', true);
        } else {
            abbottInput.prop('disabled', false);
        }
    }

    handleAbbottInputChanged() {
        const abbottInput = this.dom.find('#target_search_abbott_customer_number');
        const abbottValue = (abbottInput.val() ?? '').trim();
        const demographicInputs = this.dom.find(this.demographicFieldsSelector);

        if (abbottValue.length > 0) {
            demographicInputs.each((index, elem) => {
                $(elem).val('');
            });
            demographicInputs.prop('disabled', true).removeClass('is-invalid');
            this.dom.find('#error-message').empty().hide();
        } else {
            demographicInputs.prop('disabled', false);
        }
    }

    hcpComplianceCheck(targetId){
        // console.log("running HCP Compliance check with " + targetId);
        let response = $.ajax({
            url     : 'api/attendance/compliancecheck',
            method  : 'get',
            dataType: 'json',
            async   : false,
            data    : {
                target_id: targetId,
                meeting_id: $("#meeting_id").val()
            }
        });
        return response.responseJSON;
    }

    validateNpi(npi) {
        if (npi !== "") {
          npi = npi.split("");
          let checkBit = parseInt(npi.pop()),
            npiDouble = [],
            npiUnchanged = [];
          npi.reverse();

          for (let i = 0; i < npi.length; i++) {
            if (i % 2 === 0) {
              npiDouble.push(npi[i] * 2);
            }

            if (i % 2 === 1) {
              npiUnchanged.push(npi[i]);
            }
          }

          npiDouble = npiDouble.toString().replace(/,/g, "");
          npiUnchanged = npiUnchanged.toString().replace(/,/g, "");
          let total = npiUnchanged + npiDouble,
            totalSum = 0;

          for (let i = 0; i < total.length; i++) {
            totalSum += parseInt(total.charAt(i));
          }

          totalSum += 24; // Magic Number
          let final = Math.ceil(totalSum / 10) * 10;
          return final - totalSum === checkBit;
        } else {
            return true;
        }
    }

    checkNpiValidation(errorElement, inputValue) {
        let regex = /^\d{10}$/;
        if (!regex.test(String(inputValue).toLowerCase()) && inputValue !== "") {
            errorElement.text('Invalid NPI number, please enter correct NPI.').show();
            return false;
        } else if (!this.validateNpi(inputValue)) {
            errorElement.text('Invalid NPI number, please enter correct NPI.').show();
            return false;
        } else {
            errorElement.empty().hide()
            return true;
        }
    }

    checkNpiNumberValidation(inputValue) {
      let regex = /^\d{10}$/;
      if (
        !regex.test(String(inputValue).toLowerCase()) ||
        !this.validateNpi(inputValue)
      ) {
        return false;
      } else {
        return true;
      }
    }


    showRestrictedTargetModal() {
        let restrictedMsg = app.appData.configs.RESTRICTED_TARGET_MESSAGE ??
        "Registration could not be completed. The selected HCP is not eligible for attendance.";
        new CustomModal({
            title: 'Restricted Target.',
            content: `<p>${restrictedMsg}</p>`,
        }).open();
    }

    isAllerganClient() {
        return (app.appData.companyKey || '').toLowerCase().includes('allergan');
    }

    isSuppressContact(value) {
        if (value === true || value === 1) {
            return true;
        }

        if (value === null || value === undefined || value === '' || value === false) {
            return false;
        }

        return ['1', 'yes'].includes(String(value).trim().toLowerCase());
    }

    isPreProgram() {
        return this.meetingPhase === 'premeeting'
            || app.pages?.attendance?.meetingPhase === 'premeeting';
    }

    shouldBlockSuppressContact(targetData) {
        const suppressContact = targetData.suppress_contact ?? targetData.suppressContact;

        return this.isAllerganClient() && this.isPreProgram() && this.isSuppressContact(suppressContact);
    }

    showSuppressContactModal() {
        const msg = 'The selected HCP is on the "No Contact" list and cannot be invited or registered in advance. They may only be registered as a walk-in on the day of the program. Please contact MedForce with any questions.';
        new CustomModal({
            title: 'No Contact',
            content: `<p>${msg}</p>`,
        }).open();
    }

    updateSearchButtonState() {
      let errorElement = this.dom.find("#error-message");
      let alertElement = this.dom.find("#alert-message");
      let hasErrorText = errorElement.text().trim().length > 0;
      let canSearchNow = this.canSearch();
      let flag = hasErrorText || !canSearchNow;
      this.dom.find('#target_filter button[type="submit"]').prop("disabled", flag);
      if (flag) {
        alertElement.show();
      } else {
        alertElement.hide();
      }
    }

    handleAddTarget(e, options = {}) {
        let button = $(e.target);
        let targetData = {
            ...this.datatable.row($(e.target).parents('tr')).data(),
            ...button.data()
        };
        targetData.preRegister = false;
        let targetEvent = (app.appData?.opco_config?.sb?.attendance?.enable_target_form ?? false) ? 'targetSelectClicked' : 'targetInviteClicked';

        if (this.shouldBlockSuppressContact(targetData)) {
            this.showSuppressContactModal();
            return;
        }

        // Restricted is the only restriction flag this flow honors (Excluded is not
        // considered). Only an exact true/1/'1' value counts as Restricted - anything
        // else (0, false, null, missing, or an unexpected value) falls back to the
        // existing eligibility processing below.
        if (targetData.restricted === 1 && (app.appData.configs.RESTRICTED_TARGET_CHECK ?? false)) {
            if (options.restrictedOverrideConfirmed) {
                // The Restricted-attendee warning was already acknowledged by the user
                // for this attendee (Yes was clicked) - flag it so the compliance
                // override can be logged once registration succeeds, and continue the
                // Add flow below instead of showing the popup again.
                targetData.perform_restricted_compliance_log = true;
            } else if (this.meetingPhase === 'postmeeting') {
                // POST-program: "Soft-block" the Restricted attendee
                let restrictedMsg = app.appData.configs.RESTRICTED_TARGET_MESSAGE ??
                    "Registration could not be completed. The selected HCP is not eligible for attendance.";
                this.restrictedTargetFailed = new CustomModal({
                    title: 'Restricted Target',
                    content: `<p>${restrictedMsg} Do you still want to proceed?</p>`,
                    buttons: [
                        {
                            text: 'Yes',
                            id: 'restricted-target-yes',
                            class: 'btn-primary',
                            close: true,
                            action: () => {
                                this.handleAddTarget(e, { ...options, restrictedOverrideConfirmed: true });
                            }
                        },
                        {
                            text: 'No',
                            id: 'restricted-target-no',
                            class: 'btn-secondary',
                            close: true,
                        },
                    ],
                });
                this.restrictedTargetFailed.open();
                targetData.preRegister = true;
                return;
            } else {
                // PRE-program: "Hard-block" the Restricted attendee
                this.showRestrictedTargetModal();
                return;
            }
        }

        // The client has HCP compliance configuration enabled
        if (!options.skipHcpComplianceCheck && this.meetingData.hcp_compliance_check) {
            const hcpComplianceRes = this.hcpComplianceCheck(targetData.targetId);

            // The Attendee is not HCP-compliant
            if (hcpComplianceRes.success === false) {
                if (this.meetingPhase === 'postmeeting') {
                    // "Soft-block" the Attendee
                    this.hcpComplianceFailed = new CustomModal({
                        title: 'Abbvie Compliance Guidelines',
                        content: "<p>The selected HCP is not approved for this program's content and cannot be added in accordance with AbbVie compliance guidelines. Do you still want to proceed?</p><p>(If you would like to request a review of this HCP's specialty, please click \"How to request review of HCP's specialty\".)</p>",
                        buttons: [
                            {
                                text: 'Yes',
                                id: 'apt-yes',
                                class: 'btn-primary',
                                close: true,
                                action: () => {
                                    this.handleAddTarget(e, { skipHcpComplianceCheck: true });
                                }
                            },
                            {
                                text: 'No',
                                id: 'apt-close',
                                class: 'btn-secondary',
                                close: true,
                            },
                        ],
                    });
                    this.hcpComplianceFailed.open();
                    return;
                } else {
                    // "Hard-block" the Attendee
                    this.hcpComplianceFailed = new CustomModal({
                        title: 'ABS Compliance Check',
                        content: '<p>' + hcpComplianceRes.message + '</p>',
                    });
                    this.hcpComplianceFailed.open();
                    return;
                }
            }
        }

        if (targetData.invDeg || targetData.invSpec) {
            let invItems = [];
            let invMessage = '';
            if (targetData.invDeg) {
                invItems.push('degree');
            }
            if (targetData.invSpec) {
                invItems.push('specialty');
            }
            let invString = invItems.join(' and ');

            if (app.appData.layout.attendance.invalid_message) {
                invMessage = '<p>' + app.appData.layout.attendance.invalid_message + '</p>';
            } else {
                invMessage = '<p>The selected HCP has an unapproved ' + invString + '. If you would like to move forward adding this HCP an exception will be created.</p>';
            }

            this.invalidMod = new CustomModal({
                title: 'Invalid ' + invString,
                content: invMessage,
                buttons: [
                    {
                        text: app.appData.layout.attendance.invalid_continue,
                        id: 'continuebtn',
                        close: true,
                        class: 'btn-primary',
                        action: () => {
                            button.remove()
                            targetData.att_type = '';

                            app.pages.attendance.dom.trigger(targetEvent, [e, targetData]);
                        }
                    },
                    {
                        text: 'Cancel',
                        id: 'cancelbtn',
                        close: true,
                        class: 'btn-primary'
                    }
                ]
            });

            this.invalidMod.open();
        } else {
            button.remove()
            targetData.att_type = '';

            app.pages.attendance.dom.trigger(targetEvent, [e, targetData]);
        }
    }
}
